import { render, staticRenderFns } from "./CuposEmergencia.vue?vue&type=template&id=50467f40"
import script from "./CuposEmergencia.vue?vue&type=script&lang=js"
export * from "./CuposEmergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports